module.exports = __webpack_public_path__ + "static/media/icon-cooking.a98955fb.svg";